import { useEffect, useState, useMemo } from "react";
import CustomTable from "./CustomTable";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import logo from "../../assets/logo.png";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
import { useSelector } from "react-redux";

export default function RemarkList() {
  const [rows, setRows] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { getRemarksList } = CustomHookForRuralDetails();
  const selectorData = useSelector((state: any) => state?.dynamicData);

  // 🔹 Redux remarks data
  const RemarksList = selectorData?.analysis?.[1] || [];
  const columns = useMemo(
    () => [
      { header: "Sl. No.", field: "sno" },
      { header: "From Date", field: "from_date" },
      { header: "To Date", field: "to_date" },
      // { header: "Region", field: "region" },
      // { header: "District", field: "district" },
      // { header: "Taluk", field: "taluk" },
      // { header: "Village", field: "village" },
      { header: "Land Type", field: "land_type" },
      { header: "Mode", field: "mode" },
      { header: "Service", field: "service" },
      { header: "Source", field: "source" },
      { header: "Chart Title", field: "chart_title" },
      { header: "Chart Type", field: "chart_type" },
      { header: "AI Insights", field: "ai_sights_contents" },
      { header: "User Remarks", field: "user_remarks" },
      { header: "Actions", field: "actions" },
    ],
    []
  );

  useEffect(() => {
    setIsLoading(true);
    getRemarksList(1);
  }, []);
  useEffect(() => {
    if (!RemarksList || RemarksList.length === 0) {
      setRows([]);
      setIsLoading(false);
      return;
    }

    const formattedRows = RemarksList.map((item: any, index: number) => {
      let aiInsights = "";

      try {
        if (Array.isArray(item.model_response)) {
          aiInsights = item.model_response.join(" ");
        } else {
          const parsedResponse = JSON.parse(item.model_response || "[]");
          aiInsights = Array.isArray(parsedResponse)
            ? parsedResponse.join(" ")
            : "";
        }
      } catch (err) {
        aiInsights =
          typeof item.model_response === "string" ? item.model_response : "";
      }

      return {
        ...item,
        sno: index + 1,
        from_date: item.from_date
          ? new Date(item.from_date)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
              })
              .replace(/\//g, "-")
          : "-",
        to_date: item.to_date
          ? new Date(item.to_date)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
              })
              .replace(/\//g, "-")
          : "-",
        ai_sights_contents: aiInsights,
        land_type: Array.isArray(item?.land_type)
          ? item.land_type.join(", ")
          : item?.land_type || "-",
        mode: Array.isArray(item?.mode)
          ? item.mode.join(", ")
          : item?.mode || "-",
        service: Array.isArray(item?.service)
          ? item.service.join(", ")
          : item?.service || "-",
        source: Array.isArray(item?.source)
          ? item.source.join(", ")
          : item?.source || "-",
        user_remarks: item?.user_remarks || "-",
        chart_type_id: item?.chart_type_id || item?.chart?.chart_type_id || "-",
        chart_id: item?.chart_id || "-",
        chart_type: item?.chart_type_name || "-",
        chart_title: item?.title || "-",
        json_data: item?.json_data || "-",
        region: Array.isArray(item?.region)
          ? item.region.join(", ")
          : item?.region || "-",
        district: Array.isArray(item?.district)
          ? item.district.join(", ")
          : item?.district || "-",
        taluk: Array.isArray(item?.taluk)
          ? item.taluk.join(", ")
          : item?.taluk || "-",
        village: Array.isArray(item?.village)
          ? item.village.join(", ")
          : item?.village || "-",
        created_at: item?.created_at
          ? new Date(item.created_at).toLocaleString("en-GB")
          : "-",
        actions: "view",
      };
    });

    setRows(formattedRows);
    setIsLoading(false);
  }, [RemarksList]);

  return (
    <>
      {/* Header */}
      <div className="w-screen bg-[rgb(149,174,214)] relative left-1/2 right-1/2 ml-[-50vw] mr-[-50vw]">
        <img src={logo} alt="Header" className="w-full h-24 object-contain" />
      </div>

      <div className="p-4">
        {/* Loader */}
        <DynamicLoader loading={isLoading} />

        {/* Table */}
        {!isLoading && rows.length > 0 && (
          <CustomTable title="Remark List" columns={columns} rows={rows} />
        )}

        {/* No Data */}
        {!isLoading && rows.length === 0 && (
          <div className="text-center text-gray-500 mt-6">
            No data available
          </div>
        )}
      </div>
    </>
  );
}
